var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return (() => {
                  return false
                }).apply(null, arguments)
              },
              submit: function ($event) {
                $event.preventDefault()
                return (() => {
                  return false
                }).apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(
                    _vm._s(_vm.pageTitle) + " - " + _vm._s(_vm.form.title)
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.form.resources_count > 0
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("p", { staticClass: "info-text" }, [
                      _vm._v(_vm._s(_vm.resourcesInfo)),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.form.resources_count > 0
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("table-data", {
                        attrs: {
                          route: _vm.url.getHarvest.replace(
                            ":id",
                            this.$route.params.id
                          ),
                          settings: _vm.table.settings,
                          columns: _vm.table.columns,
                          inlineFilters: _vm.table.filters,
                          autoUpdateFilter: _vm.table.autoUpdateFilter,
                          addParamsToUrl: _vm.table.addParamsToUrl,
                          loadingMsg: _vm.table.loadingMsg,
                          notFoundMsg: _vm.table.notFoundMsg,
                          orderByTemplate: _vm.table.orderByTemplate,
                          tableClass: "table-responsive-sm",
                          "select-options": {
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: "mb-1",
                            selectionText: "rows selected",
                            clearSelectionText: "clear",
                            disableSelectInfo: false, // disable the select info panel on top
                            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                          },
                        },
                        on: {
                          "error-load": _vm.showError,
                          "on-selected-rows-change": _vm.selectionChanged,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "td",
                                    { class: _vm.table.columns[0].class },
                                    [
                                      _vm._v(
                                        _vm._s(row[_vm.table.columns[0].field])
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { class: _vm.table.columns[1].class },
                                    [
                                      _vm._v(
                                        _vm._s(row[_vm.table.columns[1].field])
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { class: _vm.table.columns[2].class },
                                    [
                                      _vm._v(
                                        _vm._s(row[_vm.table.columns[2].field])
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          56895929
                        ),
                      }),
                    ],
                    1
                  ),
                ])
              : _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("p", { staticClass: "info-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            `${_vm.pageID}.resources.all_resources_imported`
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons:
                  !_vm.readonlyFormItem && _vm.form.resources_count > 0,
                cancelTitle: _vm.cancelTitle,
                submitTitle: `${_vm.pageID}.resources.actions.save.title`,
                isDisabled: _vm.form.lyrsids == 0,
              },
              on: {
                save: _vm.linkResources,
                cancel: function ($event) {
                  return _vm.handleBack(
                    `${_vm.moduleCode}.${_vm.pageID}.resources`,
                    true
                  )
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }